const getValorMasked = (value, idTipoDesconto) => {
    const TIPO_VALOR = 2;
    if (idTipoDesconto == TIPO_VALOR) {
        return value.toLocaleString("pt-br", { minimumFractionDigits: 2 });
    }
    return value;
}

const processingListProdutos = (value) => {
    const arrayDescontoProdutos = [];

    value.forEach((element) => {
        arrayDescontoProdutos.push({
            idTipoDesconto: element.idTipoDesconto,
            idProduto: element.idProduto,
            nomeProduto: element.Produtos.nomeProduto,
            prefixo: element.TipoDesconto.sufixo,
            valor: element.valorDesconto,
            valorMasked: getValorMasked(
                element.valorDesconto,
                element.idTipoDesconto
            ),
        });
    });

    return arrayDescontoProdutos;
}

export default processingListProdutos;
